<template>
    <div class="comment">
        <div class="comment__icon">
            <div class="clip-circle--32x32 ma-auto" :style="comment_icon_bg"></div>
            <div class="comment__address">{{ userAddress }}</div>
        </div>
        <div class="comment__body comment-body balloon-left">
            <div class="comment-body__comment">
                {{ decodeText(userComment) }}
            </div>
            <div class="comment-body__date">
                {{ commentDate }}
            </div>
        </div>
    </div>
</template>

<style scoped>
.comment{
    display: flex;
    gap: 12px;
    white-space: nowrap;
    align-items: flex-end;
    width: 100%;
    position: relative;
}

.comment__icon{
    width: 48px;
    min-width: 48px;
    text-align: center;
    padding-bottom: 4px;
}
.comment__address{
    font-size: 11px;
}

.comment__body{
    background-color: #f1f1f1;
    color: #001d34;
    padding: 12px 20px 12px 20px;
    border-radius: 8px;
    width: calc(100% - 48px);
    white-space: wrap;
}

.comment-body{}
.comment-body__date{
    font-size: 12px;
}
.comment-body__comment{
    font-size: 14px;
    white-space: normal;
    word-wrap: break-word;
}

</style>

<script>
import CommentImage from "../assets/images/supporter.png"
import helper from "../assets/js/helper";
export default {
    props: {
        userAddress: {
            type: String,
            default: ''
        },
        userComment: {
            type: String,
            default: ''
        },
        commentDate: {
            type: String,
            default: ''
        }
    },
    data: () => ({
        comment_icon_bg: {
            backgroundImage: `url('${CommentImage}')`,
            backgroundColor: 'transparent'
        }
    }),
    methods: {
        decodeText(str) {
            return helper.decodeHtmlEscape(str);
        }
    }
}
</script>